import { version } from "process";

export const apiUrls = {
	baseUrl: process.env.REACT_APP_API_URL,
	localBaseUrl: process.env.REACT_APP_API_URL,
	live: {
		committee: {
			getCommitteeList: {
				url: '/committees',
				version: '/v1',
				requestType: 'GET'
			},
			getMainCommitteeList: {
				url: '/mainCommitteeList',
				version: '/v1',
				requestType: 'GET'
			},
			getSubCommitteeList: {
				url: '/subCommitteeList',
				version: '/v1',
				requestType: 'GET'
			}
		},
		meeting: {
			getEventList: {
				url: '/events',
				version: '/v1',
				requestType: 'GET'
			},
			getMeetingTemplateURL: {
				url: '/meetings/meetingTemaplte',
				version: '/v1',
				requestType: 'GET'
			},
			getJournalList: {
				url: '/meetings/journals',
				version: '/v1',
				requestType: 'GET'
			},
			getCommitteeWeekEvenets: {
				url: '/events',
				version: '/v1',
				requestType: 'GET'
			},
			getCountryList: {
				url: '/countryList',
				version: '/v1',
				requestType: 'GET'
			},
			getStateList: {
				url: '/stateList',
				version: '/v1',
				requestType: 'GET'
			},
			saveSymposiaProposal: {
				url: '/meetings/symposiaproposal',
				version: '/v1',
				requestType: 'POST'
			}
		},
		event: {
			searchEvents: {
				url: '/events/search',
				version: '/v1',
				requestType: 'GET'
			}
		},
		s3: {
			checkS3FileExists: {
				url: '/s3/verifyfileExists',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			}
		},
		myAgenda: {
			getMemberSubCommitteeList: {
				url: '/myagenda/getMemberSubCommitteeList',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			generateMyAgendaDocument: {
				url: '/myagenda/generateMyAgendaDocument',
				version: '/v1',
				requestType: 'POST',
				osl: 'meeting'
			}
		},
		member: {
			getEntitlementList: {
				url: '/entitlement',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			getMemberDetail: {
				url: '/member/memberDetail',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			}
		},
		myMeetingMaterials: {
			getEventList: {
				url: '/schedulemeeting/events',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			getEventCommitteeList: {
				url: '/schedulemeeting/eventcommittees',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			getEventCommitteeMeetingList: {
				url: '/schedulemeeting/eventcommitteesmeetings',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			getMainSubCommitteeList: {
				url: '/schedulemeeting/eventcommitteesmeetings',
				version: '/v1',
				requestType: 'POST',
				osl: 'meeting'
			},
			saveMeetingMaterials: {
				url: '/schedulemeeting/saveMeetingmaterials',
				version: '/v1',
				requestType: 'POST',
				osl: 'meeting'
			}
		},
		mySchedule: {
			getEventList: {
				url: '/schedulemeeting/events',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'

			},
			getEventCommitteeList: {
				url: '/schedulemeeting/eventcommitteesschedule',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			},
			getEventCommitteesScheduleMeetingList: {
				url: '/schedulemeeting/eventcommitteesschedulemeetings',
				version: '/v1',
				requestType: 'POST',
				osl: 'meeting'
			},
			getUTCTime: {
				url: '/schedulemeeting/getUTCTime',
				version: '/v1',
				requestType: 'POST',
				osl: 'meeting'
			}
		},
		MAE: {
			 getAccountNumber: {
				url: '/getAccountNumberThroughMAE',
				version: '/v1',
				requestType: 'GET',
				osl: 'meeting'
			}
		},
		featureFlag: {
			getfeatureFlag: {
				url: '/master/featureflag',
				version: '/v1',
				requestType: 'GET',
				osl: 'openapi'
			}
		}
	}
}

function getApiUrl(key, name) {
	if (apiUrls.live[key] && apiUrls.live[key][name] && apiUrls.live[key][name]['osl'] == 'meeting') {
		apiUrls.baseUrl = process.env.REACT_APP_MEETING_API_URL;
		apiUrls.localBaseUrl = process.env.REACT_APP_MEETING_API_URL;
	}
	else {
		apiUrls.baseUrl = process.env.REACT_APP_API_URL;
		apiUrls.localBaseUrl = process.env.REACT_APP_API_URL;
	}

	let url
	if (apiUrls.baseUrl !== null) {
		if (apiUrls.live[key] && apiUrls.live[key][name]) {
			url = apiUrls.baseUrl + apiUrls.live[key][name]['version'] + apiUrls.live[key][name]['url']
		} else {
			if (apiUrls.local[key] && apiUrls.local[key][name]) {
				url = apiUrls.localBaseUrl + apiUrls.local[key][name]['version'] + apiUrls.local[key][name]['url']
			}
		}
	} else {
		if (apiUrls.local[key] && apiUrls.local[key][name]) {
			url = apiUrls.localBaseUrl + apiUrls.local[key][name]['version'] + apiUrls.local[key][name]['url']
		}
	}
	return url
}

export default getApiUrl
